import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toggleModal } from "../store/common";
import { clearDualCartItems, fillDualCartItems, importDualCartProduct } from "../store/cart";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Input
} from "reactstrap";
import Redbtn from "../molecules/components/RedBtn";
import { RingLoader } from "react-spinners";
import { getTranslate } from "react-localize-redux";
import * as Papa from "papaparse";

const DualCartModal = ({
  getModalStatus,
  toggleModal,
  csvData,
  importCSVdata,
  isImporting,
  translate, getFile,
  selectedCustomer,
  isUploaded
}) => (
  <Modal
    size="lg"
    className="customer_dual_cart"
    isOpen={getModalStatus}
    toggle={() => toggleModal("customer_dual_cart", false)}
  >
    <ModalHeader>
      {" "}
      <h1>{translate("containers.dualCartModal.modal_header")}</h1>
    </ModalHeader>
    <ModalBody>
      <RingLoader
        color={"#d42e2b"}
        loading={isImporting}
        size={120}
        margin={20}
      />
      {!isImporting && csvData.length ? (
        <Table hover>
          <thead>
            <tr>
              <th>{translate("containers.dualCartModal.product_code")}</th>
              <th>Špeciálna cena</th>
              <th>Stav</th>
            </tr>
          </thead>
          <tbody>
            {csvData &&
              csvData.length > 0 &&
              csvData.map((row, index) => (
                <tr key={index}>

                  <td>{row.code}</td>
                  <td>{row.price}</td>
                  <td>{row.isSpecial === true && 'Nahrané'}{row.isSpecial === false && 'Nenahrané'}{!selectedCustomer && '-'}</td>
                </tr>
              ))}
          </tbody>
        </Table>
      ) : (
        <div className="cartBar__actions">
          <input
            id="file"
            type="file"
            onChange={getFile}
            className={"cartBar__actions__import fileBtn"}
          />
          <label htmlFor="file">
            {//isImportModalOpened ? "Uploading..." : "Import CSV"
              'Nahrať CSV'
            }
          </label>
        </div>
      )}
    </ModalBody>
    <ModalFooter>
      <Button
        color="secondary"
        onClick={() => {
          toggleModal("customer_dual_cart", false);
        }
        }
      >
        {translate("containers.dualCartModal.close")}
      </Button>
      {(!isUploaded) && (

        <Redbtn
          icon="fa fa-shopping-cart"
          title={translate("containers.dualCartModal.import")}
          action={() => {
            if (!isImporting) {
              importCSVdata(selectedCustomer, csvData)
            }
          }}

        />
      )}
    </ModalFooter>
  </Modal>
);

DualCartModal.propTypes = {};

const mapStateToProps = ({ cart, common, locale }) => ({
  translate: getTranslate(locale),
  getModalStatus: common.modals.customer_dual_cart
    ? common.modals.customer_dual_cart
    : null,
  csvData: cart.dualData.list || [],
  isImporting: cart.loadingImport,
  selectedCustomer: cart.dualData.customerId,
  isUploaded: cart.dualData.isUploaded
});

const mapDispatchToProps = dispatch => ({
  toggleModal: (modalName, action) => {
    dispatch(clearDualCartItems());
    dispatch(toggleModal(modalName, action))
  },
  importCSVdata: (customerId, list) => {
    dispatch(importDualCartProduct(customerId, list))
  },
  getFile: e => {
    Papa.parse(e.target.files[0], {
      delimiter: ";",
      header: false,
      complete(results) {
        const rows = results.data
          .filter(d => d.length > 1)
          .map(d => {
            return { code: d[0], price: d[1] };
          });
        var data = Object.values(
          rows.reduce((c, { code, price }) => {
            c[code] = c[code] || { code, price: 0 };
            c[code].price = price;
            return c;
          }, {})
        );
        dispatch(fillDualCartItems(data));
      }
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DualCartModal);



// WEBPACK FOOTER //
// ./src/containers/DualCartModal.js